import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-rich-text-renderer',
    templateUrl: './rich-text-renderer.component.html',
    styleUrls: ['./rich-text-renderer.component.scss']
})
export class RichTextRendererComponent implements OnChanges {
  @Input() text: string = '';

  safeHtml: SafeHtml | null = null;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['text']) {
      this.processText();
    }
  }

  private processText() {
    if (!this.text) {
      this.safeHtml = null;
      return;
    }

    // WCAG: Ensure all <img> tags have an alt attribute (add alt="" for decorative if missing)
    const processedText = this.text.replace(
      /<img(?![^>]*\balt\s*=)/gi,
      '<img alt=""'
    );

    // Treat the input as trusted HTML.
    // This assumes the source (admin/internal tools) provides safe content.
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(processedText);
  }
}
